<template>
  <div class="login-container">
    <div class="login-form">
      <h2>管理员登录</h2>
      <div class="form-group">
        <label for="username">用户名:</label>
        <input 
          type="text" 
          id="username" 
          v-model="loginData.username"
          placeholder="请输入用户名"
          required
          @keyup.enter="handleLogin"
        >
      </div>
      <div class="form-group">
        <label for="password">密码:</label>
        <input 
          type="password" 
          id="password" 
          v-model="loginData.password"
          placeholder="请输入密码"
          required
          @keyup.enter="handleLogin"
        >
      </div>
      <button @click="handleLogin" class="login-btn">登录</button>
      <div v-if="error" class="error-message">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Login',
  data() {
    return {
      loginData: {
        username: '',
        password: ''
      },
      error: ''
    }
  },
  methods: {
    async handleLogin() {
      if (!this.loginData.username || !this.loginData.password) {
        this.error = '请输入用户名和密码'
        return
      }
      
      try {
        const res = await api.auth.login(this.loginData)
        console.log('登录响应数据:', res)
        
        if (res.success) {
          const {data} = res
          // 存储token和用户信息，兼容不同的token字段名
          const token = data.access_token || data.token
          if (token) {
            localStorage.setItem('token', token)
            console.log('Token已保存:', token)
          } else {
            console.error('响应中未包含token')
          }
          
          if (data.user) {
            localStorage.setItem('user', JSON.stringify(data.user))
          }
          
          // 跳转到管理页面
          this.$router.push('/admin/products')
        } else {
          this.error = data.message || '登录失败'
        }
      } catch (error) {
        console.error('登录错误:', error)
        this.error = error.response?.data?.message || '登录失败，请稍后重试'
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  background: #222;
}

.login-form {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

h2 {
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
}

.form-group {
  margin-bottom: 1.5rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: #555;
}

input {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.login-btn {
  width: 100%;
  padding: 0.8rem;
  background: #004a99;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s;
  border: 1px solid #ddd;
}

.login-btn:hover {
  background: #fff;
  color: #000;
}

.error-message {
  margin-top: 1rem;
  padding: 0.8rem;
  background: #f44336;
  color: white;
  border-radius: 4px;
  text-align: center;
}
</style>